import {PlacementType, SubsectionScreenPlacement, Section} from '@amzn/showtime';

import {getUri, getUriRegexString, JobSearchWebSubsectionPlacementURI} from '../../utils/uriUtils/uriUtils';

const placement: SubsectionScreenPlacement = {
  id: JobSearchWebSubsectionPlacementURI.id,
  title: 'Level 1-2',
  type: PlacementType.SubsectionScreen,
  sectionId: Section.Job,
  initialUri: getUri(JobSearchWebSubsectionPlacementURI),
  uri: getUriRegexString(JobSearchWebSubsectionPlacementURI),
};

export default placement;
